const COLOR_PALLETE = [
    '#B70D00',
    '#DC3E01',
    '#F6CB04',
    '#278b01',
    '#266B76',
    '#334DCF',
    '#5301EB',
    '#000000',
    '#EB9694',
    '#FAD0C3',
    '#FDF3BD',
    '#C1E1C5',
    '#BEDADC',
    '#C4DEF6',
    '#BED3F3',
    '#D4C4FB',
    '#CCCCCC'];
export const DEFAULT_ANNOTATION_COLOR = '#FCCB00';

export const getRandomColor = () => COLOR_PALLETE[Math.floor((Math.random() * COLOR_PALLETE.length))];

export default {
    DEFAULT_ANNOTATION_COLOR,
    getRandomColor
};
